/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { useParams, useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';

/* 🧩 COMPONENTS */
import { Button, Input, Label, SelectEquipment, CustomLoading, Breadcrumb } from "../../../Components/index.js";

/* 🔗 SERVICE */
import { HistoricServices } from "../../../Services/historicosServices/index.js";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store/index.js";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeHistoricLoading } from "../../../Redux/Actions/index.js";

/* 🎨 STYLES */
import { HeaderContainer, BodyContainer, ContainerTable, Table, TableHeader, 
    TableRow, TableCell, ContainerSpinner, NoData, TableCellItem, ContainerIten } from "./styles";
import { Container } from "../../styles.js";

/* 🔧 UTILS */
import { isValidStartData, isValidEndData } from "../../../util/validate.js";

const HistoricOperationMode = () => {
    const { t } = useTranslation();

    document.title = t("reports.sub-items.history.operation-mode.document-title");
    const { id } = useParams();

    const navigationFlow =  [
        { text: 'reports', page: null },
        { text: 'history', page: `/historico/${id}` },
        { text: 'operating-mode', page: null },
    ]

    const navigate = useNavigate();
    const services = useRef(new HistoricServices());
    const location = useLocation();
    let data1 = location.state?.data1;
    let data2 = location.state?.data2;

    const [datainicio, setDatainicio] = useState(data1 ? data1 : new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10) + 'T00:00');
    const [datafim, setDatafim] = useState(data2 ? data2 : new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10) + 'T23:59:59');

    const listOperationMode = useSelector(state => state.HistoricReducer.listOperationMode);
    const isLoading = useSelector(state => state.HistoricReducer.isLoading);
    const equipaments = useSelector(state => state.HistoricReducer.equipamentList);
    const Cities = useSelector(state => state.HistoricReducer.cities);
    const city = useSelector(state => state.HistoricReducer.city);
    
    function formatarDataParaYMDHMS(data) {
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    function formatarDataParaMDHMS(data) {
        let newdata = new Date(data);
        const month = String(newdata.getMonth() + 1).padStart(2, '0');
        const day = String(newdata.getDate()).padStart(2, '0');
        const hours = String(newdata.getHours()).padStart(2, '0');
        const minutes = String(newdata.getMinutes()).padStart(2, '0');
        
        return `${day}/${month} - ${hours}:${minutes}`;
    }
    
    async function getData(){
        store.dispatch(changeHistoricLoading(true));
        let startData = formatarDataParaYMDHMS(new Date(datainicio));
        let endData = formatarDataParaYMDHMS(new Date(datafim));
        await services.current.getOperationData(id, startData, endData);
        store.dispatch(changeHistoricLoading(false));
    }

    useEffect(() => {
        services.current.getPocos();
        services.current.getCities();
    }, []);

    useEffect(() => {
        if(id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined'){
            setTimeout(() => {
                services.current.changeCity(id);
            }, 6000);
        }
    }, [id]);

    useEffect(() => {
        async function getData(){
            store.dispatch(changeHistoricLoading(true));
            let startData = formatarDataParaYMDHMS(new Date(data1 ? data1 : new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10) + 'T00:00'));
            let endData = formatarDataParaYMDHMS(new Date(data2 ? data2 : new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 16)));
            await services.current.getOperationData(id, startData, endData);
            store.dispatch(changeHistoricLoading(false));
        }

        if(id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined'){
            getData();
        }
    }, [id, data1, data2, t]);

    return (
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <HeaderContainer>
                    <div className="selects">
                        <SelectEquipment Color={'white'} options={Cities} value={city} onChange={(e) => services.current.filterEquipaments(e.target.value)} />
                        <SelectEquipment Color={'white'} options={equipaments} value={id} onChange={(e) => {
                            if(e.target.value === '' || e.target.value === null || e.target.value === undefined){
                                toast(t("message.select-equipment"), {
                                    position: "top-center",
                                    type: 'info',
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: false,
                                    draggable: false,
                                    progress: undefined,
                                });
                                return
                            }else{
                                services.current.changeCity(e.target.value);
                                navigate(`/historico/operacao/${e.target.value}`, {state: {data1: datainicio, data2: datafim}});
                            }
                        }} />
                    </div>
                    <div className="buttons-container">
                        <Button width={'fit-content'} text={t("buttons.general-overview")} onClick={() => {
                            navigate(`/historico/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                        <Button width={'fit-content'} text={'Detalhar'} onClick={() => {
                            navigate(`/historico/detalhes/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                        <Button width={'fit-content'} text={'Análises'} onClick={() => {
                            navigate(`/historico/analises/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                    </div>
                </HeaderContainer>

                <HeaderContainer>
                    <div>
                        <Label text={t("inputs.initial-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datainicio' 
                            name='datainicio' 
                            type="datetime-local" 
                            placeholder= {t("inputs.initial-date.placeholder") }
                            value={datainicio}
                            max={datafim}
                            // innerRef={UserField}
                            invalidMessage = {t("inputs.initial-date.invalid-message")}
                            validationFunction = {(text) => isValidStartData(text, datafim)}
                            onchange={(text) => setDatainicio(text)}> 
                        </Input>
                    </div>
                    <div>
                        <Label text={t("inputs.final-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datafim' 
                            name='datafim' 
                            type="datetime-local" 
                            placeholder= {t("inputs.final-date.placeholder") }
                            value={datafim}
                            min={datainicio}
                            invalidMessage = {t("inputs.final-date.invalid-message")}
                            validationFunction = {(text) => isValidEndData(datainicio, text)}
                            onchange={(text) => setDatafim(text)}> 
                        </Input>
                    </div>
                    <Button text={t("buttons.apply")} width={'fit-content'} color={'green'} onClick={() => getData()}/>
                </HeaderContainer>

                <BodyContainer>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    : id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined' &&
                        <>
                            {listOperationMode?.length > 0 ?
                                listOperationMode.map((part, index)=>(
                                    <ContainerIten key={index}>
                                        {part.data.length > 0 ?
                                            <>
                                                <ContainerSpinner>
                                                    <NoData>{part.title}</NoData>
                                                </ContainerSpinner>
                                                <ContainerTable>
                                                    <Table>
                                                        <thead>
                                                            <TableRow>
                                                                <TableHeader>{t("header-table.schedule")}</TableHeader>
                                                                <TableHeader>{t("header-table.operating-mode")}</TableHeader>
                                                                <TableHeader>{t("header-table.status")}</TableHeader>
                                                            </TableRow>
                                                        </thead>
                                                        <tbody>
                                                                {part.data.map((item, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>
                                                                            <TableCellItem>
                                                                                {formatarDataParaMDHMS(item.created_at)}
                                                                            </TableCellItem>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <TableCellItem>
                                                                                {item.operationMode}
                                                                            </TableCellItem>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <TableCellItem>
                                                                                {item.status}
                                                                            </TableCellItem>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </ContainerTable>
                                            </>
                                        :
                                            <ContainerSpinner>
                                                <NoData>Sem dados de {part.title}</NoData>
                                            </ContainerSpinner>
                                        }
                                    </ContainerIten> 
                                    ))
                            :
                                <ContainerSpinner>
                                    <NoData>{t("reports.sub-items.history.operation-mode.no-data")}</NoData>
                                </ContainerSpinner>
                            }
                        </>}
                </BodyContainer>
            </Container>
        </>
    );
}

export default HistoricOperationMode;